import { GridModel } from "common/models/utility-models/list-utility.model";
import { DashboardModel } from "./dashboard-data-model";

export class DashboardGridModel extends DashboardModel { }

export class DashboardListingModel extends GridModel<DashboardModel> {
  filterData: any;
}